import Item, { withItemFocus, withItemClick } from '@atlaskit/item';

export default withItemClick(withItemFocus(Item));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dropdown-menu/dist/esm/components/item/DropdownItem.js
// module id = 433
// module chunks = 0